module.exports = __webpack_public_path__ + "4990fd5b31d4cbe0d96b1e7ee8783f07.png";